if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        if (isTesting) {
          const firstSlide = this.elements.viewer.querySelector('.slider__slide:not(.is-active)');
          if (firstSlide) {
            const clonedSlide = firstSlide.cloneNode(true);
            const originalId = clonedSlide.id;
            const newId = `${originalId}-test`;
            clonedSlide.id = newId;
            const mediaId = clonedSlide.getAttribute('data-media-id');
            const newMediaId = `${mediaId}-test`;
            clonedSlide.setAttribute('data-media-id', newMediaId);
            clonedSlide.classList.add('test-slide');
            firstSlide.parentNode.insertBefore(clonedSlide, firstSlide.nextSibling);
          }

          const firstThumbnail = this.elements.thumbnails.querySelector('.thumbnail-list__item:not(:has(button[aria-current="true"]))');
          if (firstThumbnail) {
            const clonedThumbnail = firstThumbnail.cloneNode(true);
            const originalThumbId = clonedThumbnail.id;
            const newThumbId = `${originalThumbId}-test`;
            clonedThumbnail.id = newThumbId;
            const thumbnailImg = clonedThumbnail.querySelector('img');
            if (thumbnailImg) {
              const originalImgId = thumbnailImg.id;
              thumbnailImg.id = `${originalImgId}-test`;
            }
            const targetId = clonedThumbnail.getAttribute('data-target');
            const newTargetId = `${targetId}-test`;
            clonedThumbnail.setAttribute('data-target', newTargetId);
            const originalPosition = parseInt(clonedThumbnail.getAttribute('data-media-position'));
            const newPosition = originalPosition + 1;
            clonedThumbnail.setAttribute('data-media-position', newPosition);
            clonedThumbnail.classList.add('test-thumbnail');
            firstThumbnail.parentNode.insertBefore(clonedThumbnail, firstThumbnail.nextSibling);

            const allThumbnails = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
            allThumbnails.forEach((thumb, index) => {
              if (index >= newPosition) {
                thumb.setAttribute('data-media-position', index + 1);
              }
            });
          }

          setTimeout(() => {
            const viewerSlider = this.elements.viewer.querySelector('slider-component');
            if (viewerSlider) {
              viewerSlider.sliderItems = viewerSlider.querySelectorAll('[id^="Slide-"]');
              viewerSlider.initPages();
            }

            const thumbnailsSlider = this.elements.thumbnails.querySelector('slider-component');
            if (thumbnailsSlider) {
              thumbnailsSlider.sliderItems = thumbnailsSlider.querySelectorAll('[id^="Slide-"]');
              thumbnailsSlider.initPages();
            }
          }, 0);
        }

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        if (this.dataset.scrollback === 'true') {
          window.setTimeout(() => {
            if (this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          });
        }
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        const thumbnailsSlider = this.elements.thumbnails.querySelector('slider-component');
        if (thumbnailsSlider) {
          thumbnailsSlider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}
